import { FormHelperText, styled } from "@mui/material";

import { ClearInput, TextFieldCustom } from "components";
import useDatePickerState from "./_common/useDatePickerState";
import CalendarIconAdornment from "./_common/CalendarIconAdornment";
import CommonDayPicker from "./_common/CommonDayPicker";
import clsx from "clsx";

const ContainerStyled = styled("div")(({ theme }) => ({
  label: "range-picker-root",
  width: "100%",
  cursor: "pointer",
  "& .range-picker-textfield": {
    "& input": {
      cursor: "inherit",
    },
  },
  "& .MuiInputBase-root": {
    cursor: "inherit",
  },
  "& .date-icon": {
    color: theme.palette.text.secondary,
  },
  "& .clear-icon": {
    marginRight: "0.75rem",
    "&.hidden": {
      display: "none",
    },
  },
}));

const DayRangePicker = ({
  availableDates,
  className,
  defaultValue,
  formatDisplay = "DD/MM/YYYY",
  formatValue,
  helperText,
  iconSize = "small",
  isError,
  isLoading,
  isDisabled,
  isFullWidth,
  isViewMode,
  isClearable,
  maxDate,
  minDate,
  minSpan,
  maxSpan,
  onChange,
  onMonthChange,
  showYears,
  selectYears,
  label,
  placeholder,
  value,
}) => {
  const {
    innerValue,
    displayedRangeText,
    defaultMonth,
    isOpen,
    anchorEl,
    handleOpen,
    handleClose,
    handleChange,
    disableDate,
    hasValue,
    clear,
  } = useDatePickerState({
    value,
    isDisabled,
    isViewMode,
    isLoading,
    defaultValue,
    formatDisplay,
    formatValue,
    availableDates,
    variant: "range",
    onChange,
  });

  return (
    <ContainerStyled className={className}>
      <TextFieldCustom
        label={label}
        value={displayedRangeText}
        placeholder={placeholder}
        isReadOnly
        isLoading={isLoading}
        isFullWidth={isFullWidth}
        isViewMode={isViewMode}
        isDisabled={isDisabled}
        isError={isError}
        slotProps={{
          input: {
            startAdornment: (
              <CalendarIconAdornment
                iconSize={iconSize}
                className="date-icon"
              />
            ),
            endAdornment: (
              <ClearInput
                hasValue={hasValue}
                onClear={clear}
                className={clsx("clear-icon", { hidden: !isClearable })}
              />
            ),
          },
        }}
        className="range-picker-textfield"
        onClick={handleOpen}
      />
      <CommonDayPicker
        value={value}
        innerValue={innerValue}
        variant="range"
        isOpen={isOpen}
        anchorEl={anchorEl}
        defaultMonth={defaultMonth}
        disableDate={disableDate}
        minDate={minDate}
        maxDate={maxDate}
        minSpan={minSpan}
        maxSpan={maxSpan}
        showYears={showYears}
        selectYears={selectYears}
        onClose={handleClose}
        onChange={handleChange}
        onMonthChange={onMonthChange}
      />
      <FormHelperText error={Boolean(isError)}>{helperText}</FormHelperText>
    </ContainerStyled>
  );
};

export default DayRangePicker;
